import { Moment } from 'moment';
import { apiGet, apiPost, API_URI } from './index';

const topAuthors = {
    getAll: async (projectId: number, dateFrom: Moment, dateTo: Moment, streamIds: number[]) => {
        const data = await apiGet(`${API_URI}/api/topauthors?projectId=${projectId}&startDate=${dateFrom.format("DD MMM YYYY HH:mm:ss")}&endDate=${dateTo.format("DD MMM YYYY HH:mm:ss")}&streamIds=${streamIds.join(",")}`);
        return data;
    }
}

export default topAuthors;